module.exports = __webpack_public_path__ + "static/media/img_give_back@2x.6ce7d2e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_give_back@2x.jpg
// module id = 810
// module chunks = 0